import { Component, Input } from '@angular/core';
import { Szme037aResponseCdtmnySyosaiRefInfDto } from 'sg-api';

/**
 * 電気掛金情報画面
 * @export
 * @class UrikakekinElectricUrikakekinInfoComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'app-urikakekin-electric-urikakekin-info',
  templateUrl: './urikakekin-electric-urikakekin-info.component.html',
  styleUrls: ['./urikakekin-electric-urikakekin-info.component.scss']
})
export class UrikakekinElectricUrikakekinInfoComponent {
  @Input() urikakekinInfo: Szme037aResponseCdtmnySyosaiRefInfDto;

  constructor() { }

}
